import React from 'react';
import glamorous from 'glamorous';
import PrivateStackshare from '../shared/icons/private-logo.svg';
import {PHONE, TABLET} from '../../../shared/style/breakpoints';
import {MAX_PAGE_WIDTH} from '../../../shared/style/dimensions';
import RequestDemo from './request-demo';
import {CHARCOAL, WHITE, FOCUS_BLUE} from '../../../shared/style/colors';
import {WEIGHT, FONTS} from '../../../shared/style/typography';
import Dots from '../shared/icons/dots.svg';
import SimpleButton from '../../../shared/library/buttons/base/simple';

const Container = glamorous.div({
  width: '100%',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  margin: '100px 0',
  [TABLET]: {
    width: '90%',
    marginTop: 161,
    textAlign: 'center',
    flexDirection: 'column'
  },
  [PHONE]: {
    marginTop: 51
  }
});

const PrivateStackshareIcon = glamorous(PrivateStackshare)({
  height: 203,
  width: 320,
  [TABLET]: {
    width: 320,
    height: 177
  },
  [PHONE]: {
    height: 121,
    width: 191
  }
});

const PrivateStackshareDesc = glamorous.div({
  maxWidth: MAX_PAGE_WIDTH,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: ' center',
  [PHONE]: {
    minWidth: 280
  }
});

const Title = glamorous.h1({
  fontFamily: FONTS.CEREBRI_SANS_PRO,
  fontSize: 75,
  fontWeight: WEIGHT.ULTRA_BLACK,
  lineHeight: '72px',
  color: CHARCOAL,
  marginBottom: 11,
  marginTop: 10,
  [TABLET]: {
    fontSize: 55,
    marginTop: 37,
    marginBottom: 0
  },
  [PHONE]: {
    marginTop: 11,
    fontSize: 28,
    lineHeight: '72px'
  }
});

const SubTitle = glamorous.h2({
  fontFamily: FONTS.CEREBRI_SANS_PRO,
  fontWeight: WEIGHT.ULTRA_BLACK,
  fontSize: 30,
  lineHeight: '42px',
  color: CHARCOAL,
  margin: '10px 0',
  marginBottom: 20,
  [TABLET]: {
    marginTop: 30,
    fontSize: 28,
    marginBottom: 0
  },
  [PHONE]: {
    marginTop: 0,
    fontSize: 18,
    lineHeight: '24px'
  }
});

const Description = glamorous.p({
  fontFamily: `${FONTS.CEREBRI_SANS_PRO} !important`,
  fontSize: 24,
  fontWeight: WEIGHT.NORMAL,
  lineHeight: '44px',
  color: CHARCOAL,
  textAlign: 'center',
  marginBottom: 25,
  [TABLET]: {
    marginBottom: 35,
    fontSize: 24,
    lineHeight: '44px'
  },
  [PHONE]: {
    marginBottom: 21,
    fontSize: 18,
    lineHeight: '33px'
  }
});

const CtaContainer = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  [PHONE]: {
    width: '100%',
    flexDirection: 'column'
  }
});

const DotsStyled = glamorous(Dots)({
  position: 'absolute',
  top: '17%',
  [TABLET]: {
    top: '36%'
  },
  [PHONE]: {
    top: '31%'
  }
});

const SignUpButton = glamorous(SimpleButton)({
  fontFamily: FONTS.CEREBRI_SANS_PRO,
  height: 58,
  fontSize: 20,
  fontWeight: WEIGHT.ULTRA_BOLD,
  background: WHITE,
  color: FOCUS_BLUE,
  borderRadius: 4,
  padding: '0 41px',
  marginRight: 66,
  letterSpacing: 0,
  '&:hover': {
    borderColor: WHITE
  },
  [PHONE]: {
    margin: 0,
    padding: 0,
    marginBottom: 23,
    width: '98%'
  }
}).withComponent('a');

const SignUpHeader = () => {
  return (
    <Container>
      <DotsStyled />
      <PrivateStackshareDesc>
        <PrivateStackshareIcon />
        <Title>StackShare Enterprise</Title>
        <SubTitle>The world’s first tech stack intelligence platform</SubTitle>
        <Description>
          StackShare Enterprise is the technology system of record for large engineering
          organizations who are running many, complex tech stacks. Eliminate silos and stop tech
          sprawl by empowering teams to make data-driven decisions about which technologies to use
          and when.
        </Description>
        <CtaContainer>
          <SignUpButton href="/manage-companies/private" title="Sign up" target="_blank">
            Sign up for Free
          </SignUpButton>
          <RequestDemo
            eventProperties={{
              index: 1,
              sectionName: 'SignupHeader'
            }}
            extraStyle={{
              fontFamily: FONTS.CEREBRI_SANS_PRO
            }}
          />
        </CtaContainer>
      </PrivateStackshareDesc>
    </Container>
  );
};

export default SignUpHeader;
